"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const DialogActions_1 = __importDefault(require("@mui/material/DialogActions"));
const DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const OpenInFull_1 = __importDefault(require("@mui/icons-material/OpenInFull"));
const CloseFullscreen_1 = __importDefault(require("@mui/icons-material/CloseFullscreen"));
const DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle"));
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const react_draggable_1 = __importDefault(require("react-draggable"));
const styles_1 = require("@mui/styles");
const react_resizable_1 = require("react-resizable");
function PaperComponent(props) {
    return ((0, jsx_runtime_1.jsx)(react_draggable_1.default, Object.assign({ handle: '#draggable-dialog-title', cancel: '[class*="MuiDialogContent-root"]' }, { children: (0, jsx_runtime_1.jsx)(Paper_1.default, Object.assign({}, props)) })));
}
const useStyles = (0, styles_1.makeStyles)((theme) => (0, styles_1.createStyles)({
    resizable: {
        position: 'relative',
        '& .react-resizable-handle': {
            position: 'absolute',
            width: 20,
            height: 20,
            bottom: 0,
            right: 0,
            background: "url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2IDYiIHN0eWxlPSJiYWNrZ3JvdW5kLWNvbG9yOiNmZmZmZmYwMCIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI2cHgiIGhlaWdodD0iNnB4Ij48ZyBvcGFjaXR5PSIwLjMwMiI+PHBhdGggZD0iTSA2IDYgTCAwIDYgTCAwIDQuMiBMIDQgNC4yIEwgNC4yIDQuMiBMIDQuMiAwIEwgNiAwIEwgNiA2IEwgNiA2IFoiIGZpbGw9IiMwMDAwMDAiLz48L2c+PC9zdmc+')",
            'background-position': 'bottom right',
            padding: '0 3px 3px 0',
            'background-repeat': 'no-repeat',
            'background-origin': 'content-box',
            'box-sizing': 'border-box',
            cursor: 'se-resize',
        },
    },
}));
function CalcDialog({ onClose }) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(true);
    const [isFullscreen, setIsFullscreen] = React.useState(false);
    const [boxSize, setBoxSize] = React.useState({ width: 720, height: 510 });
    const toggleFullscreen = () => {
        setIsFullscreen(!isFullscreen);
    };
    const handleResize = (event, { size }) => {
        setBoxSize(size);
    };
    const iframeStyles = {
        border: '0px #ffffff none',
        height: isFullscreen ? '70vh' : `${boxSize.height - 120}px`,
        width: isFullscreen ? '50vw' : `${boxSize.width - 50}px`,
        transition: 'all 0.3s ease',
    };
    const closeDialog = () => {
        setOpen(false);
        if (onClose) {
            onClose();
        }
    };
    const handleClose = (e, reason) => {
        if (reason !== 'backdropClick')
            closeDialog();
    };
    return (
    // <Dialog
    //     open={open}
    //     hideBackdrop
    //     disableEnforceFocus
    //     disableEscapeKeyDown
    //     maxWidth="lg"
    //     style={{ pointerEvents: 'none' }}
    //     PaperProps={{ style: { pointerEvents: 'auto' } }}
    //     onClose={handleClose}
    //     PaperComponent={PaperComponent}
    //     aria-labelledby="draggable-dialog-title"
    // >
    //     <DialogTitle style={{ cursor: 'move', height: 45 }} id="draggable-dialog-title">
    //         <IconButton
    //             aria-label="FullScreen"
    //             onClick={toggleFullscreen}
    //             sx={{
    //                 position: 'absolute',
    //                 right: 50,
    //                 top: 8,
    //                 color: (theme) => theme.palette.grey[500],
    //             }}
    //         >
    //             {isFullscreen ? <CloseFullscreenIcon /> : <OpenInFullIcon />}
    //         </IconButton>
    //         <IconButton
    //             aria-label="close"
    //             onClick={() => closeDialog()}
    //             sx={{
    //                 position: 'absolute',
    //                 right: 9,
    //                 top: 8,
    //                 color: (theme) => theme.palette.grey[500],
    //             }}
    //         >
    //             <CloseIcon />
    //         </IconButton>
    //     </DialogTitle>
    //     <DialogContent
    //         sx={{ padding: '5px' }}
    //     >
    //         <iframe
    //             src="https://www.desmos.com/calculator"
    //             name="myiFrame"
    //             scrolling="no"
    //             style={iframeStyles}
    //         />
    //     </DialogContent>
    // </Dialog>
    (0, jsx_runtime_1.jsx)(Dialog_1.default, Object.assign({ open: open, hideBackdrop: true, disableEnforceFocus: true, disableEscapeKeyDown: true, maxWidth: 'lg', style: { pointerEvents: 'none' }, PaperProps: { style: { pointerEvents: 'auto' } }, onClose: handleClose, PaperComponent: PaperComponent, "aria-labelledby": 'draggable-dialog-title' }, { children: (0, jsx_runtime_1.jsx)(react_resizable_1.ResizableBox, Object.assign({ height: isFullscreen ? window.innerHeight - 170 : boxSize.height, width: isFullscreen ? window.innerWidth - 950 : boxSize.width, minConstraints: [400, 300], maxConstraints: [1000, 800], className: classes.resizable, onResize: handleResize }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ style: { display: 'flex', flexDirection: 'column', height: '100%' } }, { children: [(0, jsx_runtime_1.jsxs)(DialogTitle_1.default, Object.assign({ style: { cursor: 'move', height: 45 }, id: 'draggable-dialog-title' }, { children: [(0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ "aria-label": 'FullScreen', onClick: toggleFullscreen, sx: {
                                    position: 'absolute',
                                    right: 50,
                                    top: 8,
                                    color: (theme) => theme.palette.grey[500],
                                } }, { children: isFullscreen ? (0, jsx_runtime_1.jsx)(CloseFullscreen_1.default, {}) : (0, jsx_runtime_1.jsx)(OpenInFull_1.default, {}) })), (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ "aria-label": 'close', onClick: () => closeDialog(), sx: {
                                    position: 'absolute',
                                    right: 8,
                                    top: 8,
                                    color: (theme) => theme.palette.grey[500],
                                } }, { children: (0, jsx_runtime_1.jsx)(Close_1.default, {}) }))] })), (0, jsx_runtime_1.jsx)(DialogContent_1.default, Object.assign({ sx: { padding: '5px' } }, { children: (0, jsx_runtime_1.jsx)("iframe", { src: 'https://www.desmos.com/calculator', name: 'myiFrame', scrolling: 'no', style: iframeStyles }) })), (0, jsx_runtime_1.jsx)(DialogActions_1.default, Object.assign({ sx: { height: '60px' } }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ color: 'primary', variant: 'contained', sx: { borderRadius: 20, margin: 1 }, onClick: closeDialog }, { children: "Close" })) }))] })) })) })));
}
exports.default = CalcDialog;
